import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Cooperative } from '../../../models/cooperatives';
import { environment } from '../../../../environments/environment';
import { Product } from '../../../models/product';
import { Onboarding } from '../../../models/onboarding';


@Component({
  selector: 'alg-image-radio',
  templateUrl: './alg-image-radio.component.html',
  styleUrls: ['./alg-image-radio.component.scss']
})
export class AlgImageRadioComponent implements OnInit {
  @Input() listItems: any[];
  @Input() default: string;
  @Input() forceIndex: Number;
  @Output() select = new EventEmitter<any>();
  public cooperatives: Cooperative[];
  public imageUrl: string;
  public currentProduct: Product;
  public currentOnboarding: Onboarding;

  public currentIndex = 0;
  public currentIndexDesktop = 1;
  public elementShowed = 3;
  public cardSelected: any;
  public cardSelectedIndex = -1;

  public showLeft = false;
  public showRight = true;

  public isTirreno: boolean = false;
  public isAlleanza: boolean = false;
  public isReno: boolean = false;

  constructor(private api: ApiService) { }

  ngOnInit() {
    this.currentIndex = 0;
    this.currentIndexDesktop = 1;
    const observer = this.api.cooperatives.subscribe((cooperatives: Cooperative[]) => {
      this.cooperatives = cooperatives;
      if (this.cooperatives.length === this.elementShowed) {
        this.showRight = false;
      }
      if (this.default) {
       this.cooperatives.forEach((c, i) => {
        if (c._id === this.default) {
          (c.name.toLowerCase().indexOf('tirreno') > -1) ? this.isTirreno = true : (c.name.toLowerCase().indexOf('reno') > -1) ? this.isReno = true : this.isAlleanza = true;
          this.cardSelectedIndex = i;
        }
       });
      }
    });
    this.imageUrl = environment.imageUrl;
  }

  selectedTirreno(index){
    this.isTirreno = !this.isTirreno;
    this.isAlleanza = false;
    this.isReno = false;

    this.cardSelected = this.cooperatives[index];
    this.cardSelectedIndex = index;
    this.select.emit(index);
  }

  selectedAlleanza(index){
    this.isTirreno = false;
    this.isAlleanza = !this.isAlleanza;
    this.isReno = false;

    this.cardSelected = this.cooperatives[index];
    this.cardSelectedIndex = index;
    this.select.emit(index);
  }
  selectedReno(index){
    this.isReno = !this.isReno;
    this.isAlleanza = false;
    this.isTirreno = false;

    this.cardSelected = this.cooperatives[index];
    this.cardSelectedIndex = index;
    this.select.emit(index);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-image-radio/alg-image-radio.component.ts